module.exports = "<nv-react-component component=\"MentoringProgram\" is-athena-app=\"true\"></nv-react-component>";